import Fiability from './assets/fiability-image.svg';
import { buildImage, Image } from '@axa-fr-axion/utils';

export const FiabilityImage: Image = buildImage(Fiability, '');
